/**
 * @generated SignedSource<<3cdd5ac86959eb7f249b030bd78c964c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useCreateFlowMutation$variables = {
  additionalInfoJSON: string;
  cloudId: string;
  createdBy: string;
  issueARI?: string | null;
  jiraHost: string;
  jiraIssueJSON?: string | null;
  repoUrl: any;
};
export type useCreateFlowMutation$data = {
  readonly devai_flowCreate: {
    readonly id: string;
  } | null;
};
export type useCreateFlowMutation = {
  response: useCreateFlowMutation$data;
  variables: useCreateFlowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "additionalInfoJSON"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdBy"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueARI"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraHost"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraIssueJSON"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repoUrl"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "additionalInfoJSON",
        "variableName": "additionalInfoJSON"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "createdBy",
        "variableName": "createdBy"
      },
      {
        "kind": "Variable",
        "name": "issueARI",
        "variableName": "issueARI"
      },
      {
        "kind": "Variable",
        "name": "jiraHost",
        "variableName": "jiraHost"
      },
      {
        "kind": "Variable",
        "name": "jiraIssueJSON",
        "variableName": "jiraIssueJSON"
      },
      {
        "kind": "Variable",
        "name": "repoUrl",
        "variableName": "repoUrl"
      }
    ],
    "concreteType": "DevAiFlowSession",
    "kind": "LinkedField",
    "name": "devai_flowCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateFlowMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreateFlowMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "283d1d691458d0b4c1687291c95e658b",
    "id": null,
    "metadata": {},
    "name": "useCreateFlowMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateFlowMutation(\n  $cloudId: String!\n  $issueARI: ID\n  $repoUrl: URL!\n  $createdBy: String!\n  $jiraHost: String!\n  $jiraIssueJSON: String\n  $additionalInfoJSON: String!\n) {\n  devai_flowCreate(issueARI: $issueARI, cloudId: $cloudId, repoUrl: $repoUrl, createdBy: $createdBy, jiraHost: $jiraHost, jiraIssueJSON: $jiraIssueJSON, additionalInfoJSON: $additionalInfoJSON) @optIn(to: \"DevAiFlowCreate\") {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "baf2202dfb2f79b9e1fe5f5751c42ef7";

export default node;
